import {ApiService} from "./api.service";
import {ApplicationHelper} from "../helpers/ApplicationHelper";

export class ResourceService extends ApiService{
  constructor(organizationId) {
    super();
    // this.endpoint = "/funds";
    this.endpoint = `/organizations/${organizationId}/resources`;
  }

  createImageResource(file) {
    const cleanFile = ApplicationHelper.sanitizeFileName(file);
    const formData = new FormData();
    formData.append("images[]", cleanFile);
    return this.upload(`${this.endpoint}/image_resource`, formData, "POST")
      .then((res) => res);
  }
}
